import Wizard from './Wizard';

export default Wizard;
